import { request } from './api';
import * as Alert from './alert';

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const RECEIVE_ANSWER = 'RECEIVE_ANSWER';
export const CLEAR = 'CLEAR';
export const SET_PREVIOUS_RESPONSE_ID = 'SET_PREVIOUS_RESPONSE_ID';

export const clear = () => ({ type: CLEAR });

export function runChat(question) {
  return (dispatch) => {
    // Modify the payload to match the desired structure

    dispatch({ type: SEND_MESSAGE, question });

    return dispatch(
      request('post', '/aitools/qa/', {
        body: { question },
      })
    ).then(
      (data) => dispatch({ type: RECEIVE_ANSWER, answer: data.result }),
      (error) =>
        dispatch(Alert.show({ type: 'error', msg: 'Error with request' }))
    );
  };
}

export function askGuide(question) {
  return (dispatch, getState) => {
    const state = getState();
    const { previous_response_id } = state.Chatbot;

    dispatch({ type: SEND_MESSAGE, question });

    return dispatch(
      request('post', `/aitools/guide-assistant/`, {
        body: {
          query: question,
          previous_response_id,
        },
      })
    ).then(
      (data) => {
        dispatch({ type: RECEIVE_ANSWER, answer: data.text });
        dispatch({
          type: SET_PREVIOUS_RESPONSE_ID,
          previous_response_id: data.response_id,
        });
      },
      (error) =>
        dispatch(Alert.show({ type: 'error', msg: 'Error with request' }))
    );
  };
}
